module.exports = "<div class=\"email-thumbnail-holder\"> <iframe scrolling=\"no\" class=\"fade-in\" id=\"desktop-preview-thumbnail\"></iframe> </div>";